import { Slide } from '@/components/core/Slide';
import audioFile from './29-transition.mp3';

// const autoNextDuration = 5000;
const transcript = `
  Jonathan, mag ik nog even snel wat tips voor verschillende type bedrijven geven?
`;

// Jonathan: Natuurlijk EVA, ga je gang. Dat lijkt me heel nuttig voor ons publiek.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      // autoNext={autoNextDuration}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
